/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Closedeal_Summary_Targetraise3Inputs */

const en_coinvestments_closedeal_summary_targetraise3 = /** @type {(inputs: Coinvestments_Closedeal_Summary_Targetraise3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target raise`)
};

/**
* | output |
* | --- |
* | "Target raise" |
*
* @param {Coinvestments_Closedeal_Summary_Targetraise3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_closedeal_summary_targetraise3 = /** @type {((inputs?: Coinvestments_Closedeal_Summary_Targetraise3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Closedeal_Summary_Targetraise3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_closedeal_summary_targetraise3(inputs)
});
export { coinvestments_closedeal_summary_targetraise3 as "coInvestments_closeDeal_summary_targetRaise" }